import { get } from 'svelte/store'
import { orgInfo, apiBaseURL } from '../stores/auth'
import { Auth as Amplify } from 'aws-amplify'
import { validateEmail } from '../scripts/helpers'
import CueError from '../scripts/error'

const orgIdEndpoint = 'https://pxxig8ib68.execute-api.us-east-1.amazonaws.com/production/org/info';
const orgIdKey = '87jjZpaE4I1EE9Lv9AMn5a7KoUfVrWnmareFmPBM';

const resources = {
  buttonDelete:                       'button/delete',
  buttonGetAll:                       'button/getall',
  buttonGetByRep:                     'button/getbyrep',
  buttonTransfer:                     'button/transfer',
  
  messagingEmailBlast:                'messaging/emailblast',
  messagingGetMessageTemplates:       'messaging/getmessagetemplates',
  messagingPostMessageTemplate:       'messaging/postmessagetemplate',
  messagingSendMessageTemplateSample: 'messaging/sendmessagetemplatesample',
  
  metricsGetMetrics:                  'metrics/getmetrics',
  
  territoriesGet:                     'territories/get',
  territoriesUpdate:                  'territories/update',
  
  userDisable:                        'user/disable',
  userEdit:                           'user/edit',
  userGetUserInfoByUsername:          'user/getuserinfobyusername',
  userGetUsers:                       'user/getusers',
  userInvite:                         'user/invite',
  userPermissions:                    'user/permissions',
  userPasswordPolicy:                 'user/password-policy',
  userRegister:                       'user/register',
  userResendInvite:                   'user/resend-invite',
  userUnsubscribe:                    'user/unsubscribe',
  userUpdateCell:                     'user/updatecell',
};

async function getToken(){
  if(!get(apiBaseURL)){
    apiBaseURL.set( get(orgInfo).apiBaseURL )
  }

  //get JWT
  try{
    const session = await Amplify.currentSession();
    return session.getIdToken().getJwtToken()
  } catch(err) {
    console.error(err);
    throw err
  }
}

async function getAccessToken(){
  if(!get(apiBaseURL)){
    apiBaseURL.set( get(orgInfo).apiBaseURL )
  }

  //get JWT
  try{
    const session = await Amplify.currentSession();
    return session.getAccessToken().getJwtToken()
  } catch(err) {
    console.error(err);
    throw err
  }
}

function getOrgInfo(orgId: string): Promise<any> {

  if (!orgId || orgId === '') throw 'orgId is blank';

  const headers = {
    'X-Api-Key': orgIdKey
  };
  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: 'GET',
      url: `${orgIdEndpoint}?orgid=${orgId}`,
      success: resolve,
      error: (response: any) => {
        if (response.status === 404) {
          reject( new CueError('Organization was not found', 'OrganizationNotFound', response) )
        } else {
          reject( new CueError('Unknown error', 'UnknownError', response) )
        }
      },
      headers: headers
    });
  });
}

function getOrgInfoByAlias(orgAlias: string): Promise<any> {
  if (!orgAlias || orgAlias === '') throw 'orgAlias is blank';

  const headers = {
    'X-Api-Key': orgIdKey
  };
  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: 'GET',
      url: `${orgIdEndpoint}?alias=${orgAlias}`,
      success: resolve,
      error: (response: any) => {
        if (response.status === 404) {
          reject( new CueError('Organization was not found', 'OrganizationNotFound', response) )
        } else {
          reject( new CueError('Unknown error', 'UnknownError', response) )
        }
      },
      headers: headers
    });
  });
}

async function invite(
    username: string, 
    orgId: string, 
    role: UserRoleType, 
    territory:string, 
    permission_add: boolean, 
    permission_delete: boolean, 
    permission_read: boolean
  ): Promise<void> {

  let jwt = await getToken();
  const data = {
    'username' : username,
    'role' : role,
    'territory' : territory,
    'permission_add' : permission_add.toString(),
    'permission_delete' : permission_delete.toString(),
    'permission_read' : permission_read.toString(),
    'orgId' : orgId
  };

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'POST',
      url: get(apiBaseURL) + resources.userInvite,
      dataType: 'json',
      data: JSON.stringify(data),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function resendInvite(username: string): Promise<void> {
  let jwt = await getToken();
  const data = {
    'username' : username,
  };

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'POST',
      url: get(apiBaseURL) + resources.userResendInvite,
      dataType: 'json',
      data: JSON.stringify(data),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt
      }
    });
  })
}

export async function register(
    apiBaseURL: string, 
    token: string, 
    first_name: string, 
    last_name: string, 
    password: string, 
    cell: string
  ): Promise<void> {
    
  const data = {
    t: token,
    first_name,
    last_name,
    password,
    cell
  };

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'POST',
      url: apiBaseURL + resources.userRegister,
      dataType: 'json',
      data: JSON.stringify(data),
      success: resolve,
      error: (response) => reject(
        new CueError(
          response.responseJSON.error.message, 
          response.responseJSON.error.code, 
          response
        ) 
      )
    });
  })
}

async function getPermissions(): Promise<any> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'GET',
      url: get(apiBaseURL) + resources.userPermissions,
      dataType: 'json',
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function transferButton(dashbuttonid:  string[], toRep: string): Promise<void> {
  let jwt = await getToken();

  const data = {
    'dashbuttonid' : dashbuttonid,
    'torep' : toRep
  };

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'POST',
      url: get(apiBaseURL) + resources.buttonTransfer,
      dataType: 'json',
      data: JSON.stringify(data),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function editUser(
    repusername: string, 
    role: UserRoleType, 
    territory: string,
    permission_add: boolean,
    permission_delete: boolean
  ): Promise<void> {

  let jwt = await getToken();
  
  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'POST',
      url: get(apiBaseURL)  + resources.userEdit,
      dataType: 'json',
      data: JSON.stringify({
        'username':repusername,
        'role':role,
        'territory':territory,
        'permissionAdd':permission_add.toString(),
        'permissionDelete':permission_delete.toString()
      }),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  });
}

async function disableUser(repusername: string, isDisabled: boolean) {
  let jwt = await getToken();

  const disabledValue = isDisabled.toString()

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'POST',
      url: get(apiBaseURL) + resources.userDisable,
      dataType: 'json',
      data: JSON.stringify({
        'username': repusername,
        'disable': disabledValue
      }),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  });
}

async function unsubscribe(
    apiBaseURL: string, 
    apiKey: string, 
    email: string
  ): Promise<void> {

  return new Promise((resolve, reject) => {    
    jQuery.ajax({
      type:'POST',
      url: apiBaseURL + resources.userUnsubscribe,
      dataType: 'json',
      data: JSON.stringify({
        'email': email
      }),
      success: resolve,
      error: reject,
      headers: {
        'X-Api-Key': apiKey,
      }
    });
  });
}

async function deleteButton(dashbuttonids: string[]): Promise<void> {
  let jwt = await getToken();

  const data = {
    'dashbuttonid' : dashbuttonids
  };

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'POST',
      url: get(apiBaseURL) + resources.buttonDelete,
      dataType: 'json',
      data: JSON.stringify(data),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function getPasswordPolicy(baseUrl: string = undefined, invitationToken: string = undefined): Promise<JSON> {
  let headers = {};
  let data    = {};

  if (invitationToken) {
    data = {
      t: invitationToken
    };
  } else {
    baseUrl = get(apiBaseURL);
    headers = {
      'Authorization': await getAccessToken()
    };
  }

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: 'GET',
      url: baseUrl + resources.userPasswordPolicy,
      headers,
      data,
      success: resolve,
      error: reject
    })
  })
}

async function updateCell(): Promise<JSON> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: 'POST',
      url: get(apiBaseURL) + resources.userUpdateCell,
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt
      }
    })
  })
}

async function emailBlast(
  dashbuttonids: string[],
  subject: string,
  html: string,
  plain: string
): Promise<JSON> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: "POST",
      dataType: "json",
      url: get(apiBaseURL) + resources.messagingEmailBlast,
      data: JSON.stringify({ dashbuttonids, subject, html, plain }),
      success: resolve,
      error: reject,
      headers: {
        Authorization: jwt,
      },
    });
  });
}

async function getMetrics(params: {}): Promise<JSON[]> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'GET',
      url: get(apiBaseURL) + resources.metricsGetMetrics,
      data: params,
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

type EditUserStringBooleanType = 'true' | 'false'
type UserRoleType = 'admin' | 'user'
type UserStatusType = 'ACTIVE' | 'INVITED'

interface GetUserDataInterface {
  repusername: string,
  created: EditUserStringBooleanType,
  disabled: EditUserStringBooleanType,
  permission_add: EditUserStringBooleanType,
  permission_delete: EditUserStringBooleanType,
  permission_read: EditUserStringBooleanType,
  role: UserRoleType,
  status: UserStatusType,
  territory: string
}

 async function getUser(username: string): Promise<GetUserDataInterface> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'GET',
      url: get(apiBaseURL) + resources.userGetUserInfoByUsername,
      data: {repusername: username},
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function getUsers(): Promise<GetUserDataInterface[]> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'GET',
      url: get(apiBaseURL) + resources.userGetUsers,
      dataType: 'json',
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function getButtonsByRep(repusername): Promise<any> {
  let jwt = await getToken();

  const data = {
    'repusername' : repusername
  };

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'GET',
      url: get(apiBaseURL) + resources.buttonGetByRep,
      data: data,
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function getButtonsByOriginalRep(originalrep: string): Promise<any> {
  let jwt = await getToken();

  const data = {
    'originalrep' : originalrep
  };

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'GET',
      url: get(apiBaseURL) + resources.buttonGetByRep,
      data: data,
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  });
}

async function getAllButtons(): Promise<any> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type:'GET',
      url: get(apiBaseURL) + resources.buttonGetAll,
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function getUnassignedButtons(): Promise<any> {
  return getButtonsByRep('Unassigned');
}




async function getMessageTemplates(): Promise<{}> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: 'GET',
      url: get(apiBaseURL) + resources.messagingGetMessageTemplates,
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  }) 
}

async function postMessageTemplate(template: string, message: string): Promise<void> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: 'POST',
      url: get(apiBaseURL) + resources.messagingPostMessageTemplate,
      dataType: 'json',
      data: JSON.stringify({
        'template': template,
        'message': message
      }),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function sampleMessageTemplate(recipient: string[], template: string, subjectPrefix: string): Promise<void> {
  let jwt = await getToken();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      type: 'POST',
      url: get(apiBaseURL) + resources.messagingSendMessageTemplateSample,
      dataType: 'json',
      data: JSON.stringify({
        'recipient': JSON.stringify(recipient),
        'template': template,
        'subjectPrefix': subjectPrefix,
      }),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
 
}

async function getTerritories(): Promise<any[]> {
  let jwt = await getToken();

  return new Promise( (resolve, reject) => {
    jQuery.ajax({
      type: 'GET',
      url: get(apiBaseURL) + resources.territoriesGet,
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

async function addTerritory(territory: string, manageremail: string) {
  let jwt = await getToken();

  return new Promise( (resolve, reject) => {
    jQuery.ajax({
      type: 'POST',
      url: get(apiBaseURL) + resources.territoriesUpdate,
      dataType: 'json',
      data: JSON.stringify({
        'operation': 'add',
        'territory': territory,
        'manageremail': manageremail,
      }),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
        'x-api-resource-version': '2'
      }
    });
  })
}

async function updateTerritory(
    previousTerritory: string, 
    territory: string, 
    manageremail: string) 
  {

  let jwt = await getToken();

  return new Promise( (resolve, reject) => {
    jQuery.ajax({
      type: 'POST',
      url: get(apiBaseURL) + resources.territoriesUpdate,
      dataType: 'json',
      data: JSON.stringify({
        'operation': 'update',
        'previousTerritory': previousTerritory,
        'territory': territory,
        'manageremail': manageremail,
      }),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
        'x-api-resource-version': '2'
      }
    });
  })
}

async function deleteTerritory(territory: string): Promise<void> {
  let jwt = await getToken();

  return new Promise( (resolve, reject) => {
    jQuery.ajax({
      type: 'POST',
      url: get(apiBaseURL) + resources.territoriesUpdate,
      dataType: 'json',
      data: JSON.stringify({
        'operation': 'delete',
        'territory': territory,
      }),
      success: resolve,
      error: reject,
      headers: {
        'Authorization':jwt,
      }
    });
  })
}

export {
  addTerritory,
  deleteButton,
  deleteTerritory,
  disableUser,
  editUser,
  emailBlast,
  getAllButtons,
  getButtonsByOriginalRep,
  getButtonsByRep,
  getMessageTemplates,
  getMetrics,
  getOrgInfo,
  getOrgInfoByAlias,
  getPermissions,
  getPasswordPolicy,
  getTerritories,
  getUnassignedButtons,
  getUser,
  getUsers,
  invite,
  postMessageTemplate,
  resendInvite,
  sampleMessageTemplate,
  transferButton,
  unsubscribe,
  updateCell,
  updateTerritory
}

export type {
  GetUserDataInterface,
  UserRoleType,
  EditUserStringBooleanType
}
